function NewUsersIcon({ size = '22', style = {} }) {
  return (
    <svg
      style={{ ...style }}
      width={size}
      height={size}
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.8487 1.35594C18.8487 1.08972 18.6415 0.873901 18.3859 0.873901C18.1303 0.873901 17.923 1.08972 17.923 1.35594V1.5361H17.7419C17.4863 1.5361 17.2791 1.75192 17.2791 2.01814C17.2791 2.28437 17.4863 2.50018 17.7419 2.50018H17.923V2.68034C17.923 2.94656 18.1303 3.16238 18.3859 3.16238C18.6415 3.16238 18.8487 2.94656 18.8487 2.68034V2.50018H19.0298C19.2854 2.50018 19.4926 2.28437 19.4926 2.01814C19.4926 1.75192 19.2854 1.5361 19.0298 1.5361H18.8487V1.35594ZM21.4001 1.20174C21.3366 1.00581 21.1601 0.873901 20.9616 0.873901C20.763 0.873901 20.5866 1.00581 20.5231 1.20174L19.8577 3.25413L18.2252 3.88379C18.0436 3.95382 17.923 4.13417 17.923 4.33583C17.923 4.5375 18.0436 4.71785 18.2252 4.78788L19.8577 5.41754L20.5231 7.46993C20.5866 7.66586 20.763 7.79777 20.9616 7.79777C21.1601 7.79777 21.3366 7.66586 21.4001 7.46993L22.0654 5.41754L23.698 4.78788C23.8796 4.71785 24.0001 4.5375 24.0001 4.33583C24.0001 4.13417 23.8796 3.95382 23.698 3.88379L22.0654 3.25413L21.4001 1.20174ZM20.6641 3.7805L20.9616 2.86278L21.2591 3.7805C21.3038 3.91835 21.4059 4.02781 21.5369 4.07833L22.2045 4.33583L21.5369 4.59334C21.4059 4.64386 21.3038 4.75332 21.2591 4.89117L20.9616 5.80889L20.6641 4.89117C20.6194 4.75332 20.5173 4.64386 20.3863 4.59334L19.7186 4.33583L20.3863 4.07833C20.5173 4.02781 20.6194 3.91835 20.6641 3.7805ZM6.08878 7.72791C6.08878 5.68775 7.668 4.09541 9.54167 4.09541C11.4153 4.09541 12.9945 5.68775 12.9945 7.72791C12.9945 9.76808 11.4153 11.3604 9.54167 11.3604C7.668 11.3604 6.08878 9.76808 6.08878 7.72791ZM9.54167 2.33822C6.63092 2.33822 4.3316 4.78526 4.3316 7.72791C4.3316 10.6706 6.63092 13.1176 9.54167 13.1176C12.4524 13.1176 14.7517 10.6706 14.7517 7.72791C14.7517 4.78526 12.4524 2.33822 9.54167 2.33822ZM5.21019 15.8715C3.81661 15.8715 2.4877 16.4484 1.51363 17.4629C0.540724 18.4761 0.00012207 19.843 0.00012207 21.2612V23.5168C0.00012207 24.002 0.393482 24.3953 0.878715 24.3953C1.36395 24.3953 1.75731 24.002 1.75731 23.5168V21.2612C1.75731 20.2865 2.12941 19.3586 2.78112 18.6799C3.43167 18.0024 4.30621 17.6287 5.21019 17.6287H13.8731C14.7771 17.6287 15.6517 18.0024 16.3022 18.6799C16.9539 19.3586 17.326 20.2865 17.326 21.2612V23.5168C17.326 24.002 17.7194 24.3953 18.2046 24.3953C18.6899 24.3953 19.0832 24.002 19.0832 23.5168V21.2612C19.0832 19.843 18.5426 18.4761 17.5697 17.4629C16.5956 16.4484 15.2667 15.8715 13.8731 15.8715H5.21019Z"
        fill="url(#paint0_linear)"
      />
      <defs>
        <linearGradient
          id="paint0_linear"
          x1="-11.9999"
          y1="12.6346"
          x2="11.5168"
          y2="36.6298"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#3A416F" />
          <stop offset="1" stopColor="#141727" />
        </linearGradient>
        <clipPath id="clip0">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(0.00012207 0.300781)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export default NewUsersIcon;
